import { createContext } from 'react';
import type { EmployerBrandDto } from '@src/api/api.types.ts';
import type { OrganizationDto } from '@src/api/queries/organization';
import type { Settings } from '@funnellab/shared/src/types/directus.ts';

export type JobWizardContextType = {
  organizations: OrganizationDto[];
  employerBrands: EmployerBrandDto[];
  settings: Settings;
};

const JobWizardContext = createContext<JobWizardContextType | undefined>(
  undefined,
);

export default JobWizardContext;
